import { render, staticRenderFns } from "./EditSectionModal.vue?vue&type=template&id=16dab8af&"
import script from "./EditSectionModal.vue?vue&type=script&lang=ts&"
export * from "./EditSectionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports